import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "./../../../assets/images/logo.png";
import { jwtDecode } from "jwt-decode";

const Sidebar = ({ isMinified }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [userRole, setUserRole] = useState(null); // State for role
  const location = useLocation(); // <-- get current location

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    console.log("Token:", token); // Debug
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserRole(parseInt(decodedToken.RoleBaseId)); // Update state with role
      } catch (error) {
        console.error("Error decoding token:", error);
        localStorage.removeItem("authToken"); // Remove invalid token
      }
    }
  }, []); // Runs only on mount


  // Helper to check if link is active
  // ...existing code...
  const isActive = (to) => {
    return location.pathname.startsWith(to);
  };

  //console.log("User Role:", userRole); // Debugging

  return (
    <aside className={`left-sidebar sidebar-dark ${isMinified ? 'sidebar-minified' : ''}`} id="left-sidebar">
      <div id="sidebar" className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
        <div className="app-brand">
          <Link to="/">
            <img src={logo} alt="Mono" />
            {/* <span className="brand-name">MONO</span> */}
            {/* <span className={`ml-2 brand-name brand-name ${isMinified ? 'hidden' : ''}`}>.</span> */}
          </Link>
        </div>
        <div className="sidebar-left" data-simplebar >
          <ul className="nav sidebar-inner" id="sidebar-menu">
            <li className={isActive("/dashboard/dashboardhome") ? "active" : ""}>
              <Link className="sidenav-item-link" to="/dashboard/dashboardhome">
                <i className="mdi mdi-briefcase-account-outline"></i>
                <span className="nav-text">Dashboard</span>
              </Link>
            </li>
            {(userRole === 1) && (
              <>
                <li className={isActive("/dashboard/chanage-home-content") ? "active" : ""}>
                  <Link className="sidenav-item-link" to="/dashboard/chanage-home-content">
                    <i className="mdi mdi-camera-image"></i>
                    <span className="nav-text">Banner and Content</span>
                  </Link>
                </li>
                <li className="section-title">Info</li>
                <li className={isActive("/dashboard/retailers") ? "active" : ""}>
                  <Link className="sidenav-item-link" to="/dashboard/retailers">
                    <i className="mdi mdi-account-details"></i>
                    <span className="nav-text">Retailers</span>
                  </Link>
                </li>
                <li className={isActive("/dashboard/guests") ? "active" : ""}>
                  <Link className="sidenav-item-link" to="/dashboard/guests">
                    <i className="mdi mdi-account-details"></i>
                    <span className="nav-text">Guests</span>
                  </Link>
                </li>

                <li className={isActive("/dashboard/pay-u-transaction") ? "active" : ""}>
                  <Link className="sidenav-item-link" to="/dashboard/pay-u-transaction">
                    <i className="mdi mdi mdi-currency-inr"></i>
                    <span className="nav-text">Pay U Transaction </span>
                  </Link>
                </li>

                {/* <li className={isActive("/dashboard/retailor-transaction-report") ? "active" : ""}>
            <Link className="sidenav-item-link" to="/dashboard/retailor-transaction-report">
              <i className="mdi mdi mdi-currency-inr"></i>
               <span className="nav-text">Retailers Transaction Report </span>
            </Link>
          </li> */}


                {/* <li className="has-sub">
                  <button className="sidenav-item-link" herf="#" onClick={() => setIsCollapsed(!isCollapsed)} data-toggle="collapse" data-target="#complete"
                    aria-expanded="false" aria-controls="email" style={{ cursor: 'pointer' }}>
                    <i className="mdi mdi-currency-inr"></i>
                    <span className="nav-text">Complete Reports</span> <b className="caret"></b>
                  </button>
                  <ul className="collapse" id="complete" data-parent="#sidebar-menu">
                    <div className="sub-menu">
                   <li className={isActive("/dashboard/new-pan-application-complete-report") ? "active" : ""}>
                      <Link className="sidenav-item-link" to="/dashboard/new-pan-application-complete-report">
                        <span className="nav-text">PAN Appln Report</span>
                      </Link>
                    </li>
                   <li className={isActive("/dashboard/camp-registration-complete-report") ? "active" : ""}>
                      <Link className="sidenav-item-link" to="/dashboard/camp-registration-complete-report">
                        <span className="nav-text">Camp Registration Report</span>

                      </Link>
                    </li>
                    <li className={isActive("/dashboard/name-publication-complete-report") ? "active" : ""}>
                      <Link className="sidenav-item-link" to="/dashboard/name-publication-complete-report">
                        <span className="nav-text">Name Publication Report</span>
                      </Link>
                    </li>
                   <li className={isActive("/dashboard/pan-object-complete-report") ? "active" : ""}>
                    <Link className="sidenav-item-link" to="/dashboard/pan-object-complete-report">
                      <span className="nav-text">PAN Object Report</span>
                    </Link>
                  </li>
                 <li className={isActive("/dashboard/pan-find-complete-report") ? "active" : ""}>
                      <Link className="sidenav-item-link" to="/dashboard/pan-find-complete-report">
                        <span className="nav-text">Pan Find Report</span>
                      </Link>
                    </li>

                 <li className={isActive("/dashboard/correction-pan-application-complete-report") ? "active" : ""}>
                    <Link className="sidenav-item-link" to="/dashboard/correction-pan-application-complete-report">
                      <span className="nav-text">Correction PAN Appln Report</span>
                    </Link>
                  </li>
    
              </div>
            </ul>
            </li> */}
              </>
            )}
            {(userRole === 2) && (
              <>
                <li className="section-title">Transaction & Report</li>
                <li>
                  <Link className="sidenav-item-link" to="retailor-transaction-report">
                    <i className="mdi mdi-currency-inr"></i>
                    <span className="nav-text">Retailers Transaction Report </span>
                  </Link>
                </li>

              </>
            )}

            {(userRole === 1 || userRole === 2) && (
              <>
                <li className="section-title">Work</li>

                <li className="has-sub">
                  <button className="sidenav-item-link" herf="#" onClick={() => setIsCollapsed(!isCollapsed)} data-toggle="collapse" data-target="#email"
                    aria-expanded="false" aria-controls="email" style={{ cursor: 'pointer' }}>
                    <i className="mdi mdi-email"></i>
                    <span className="nav-text">In-progress Reports</span> <b className="caret"></b>
                  </button>
                  <ul className="collapse" id="email" data-parent="#sidebar-menu">
                    <div className="sub-menu">
                      <li className={isActive("/dashboard/new-pan-application-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/new-pan-application-report">
                          <span className="nav-text">PAN Appln Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/camp-registration-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/camp-registration-report">
                          <span className="nav-text">Camp Registration Report</span>

                        </Link>
                      </li>
                      <li className={isActive("/dashboard/name-publication-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/name-publication-report">
                          <span className="nav-text">Name Publication Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-object-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-object-report">
                          <span className="nav-text">PAN Object Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-find-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-find-report">
                          <span className="nav-text">Pan Find Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/correction-pan-application-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/correction-pan-application-report">
                          <span className="nav-text">Correction PAN Appln Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/new-address-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/new-address-report">
                          <span className="nav-text">New Address report</span>
                        </Link>
                      </li>

                    </div>
                  </ul>
                </li>

                <li className="has-sub">
                  <button className="sidenav-item-link" herf="#" onClick={() => setIsCollapsed(!isCollapsed)} data-toggle="collapse" data-target="#complete"
                    aria-expanded="false" aria-controls="email" style={{ cursor: 'pointer' }}>
                    <i className="mdi mdi-email"></i>
                    <span className="nav-text">Complete Reports</span> <b className="caret"></b>
                  </button>
                  <ul className="collapse" id="complete" data-parent="#sidebar-menu">
                    <div className="sub-menu">
                      <li className={isActive("/dashboard/new-pan-application-complete-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/new-pan-application-complete-report">
                          <span className="nav-text">PAN Appln Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/camp-registration-complete-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/camp-registration-complete-report">
                          <span className="nav-text">Camp Registration Report</span>

                        </Link>
                      </li>
                      <li className={isActive("/dashboard/name-publication-complete-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/name-publication-complete-report">
                          <span className="nav-text">Name Publication Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-object-complete-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-object-complete-report">
                          <span className="nav-text">PAN Object Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-find-complete-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-find-complete-report">
                          <span className="nav-text">Pan Find Report</span>
                        </Link>
                      </li>

                      <li className={isActive("/dashboard/correction-pan-application-complete-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/correction-pan-application-complete-report">
                          <span className="nav-text">Correction PAN Appln Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/address-update-complete-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/address-update-complete-report">
                          <span className="nav-text">New Address Report</span>
                        </Link>
                      </li>

                    </div>
                  </ul>
                </li>

                <li className="has-sub">
                  <button className="sidenav-item-link" href="#" onClick={(e) => e.preventDefault()} data-toggle="collapse" data-target="#ui-elements"
                    aria-expanded="false" aria-controls="ui-elements" style={{ cursor: 'pointer' }}>
                    <i className="mdi mdi-account-edit"></i>
                    <span className="nav-text">Form</span> <b className="caret"></b>
                  </button>
                  <ul className="collapse" id="ui-elements" data-parent="#sidebar-menu">
                    <div className="sub-menu">
                      <li className={isActive("/dashboard/new-pan-application") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/new-pan-application" onClick={() => localStorage.removeItem("newPanId")}>
                          <span className="nav-text">New PAN Application</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/camp-registration") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/camp-registration">
                          <span className="nav-text">CAMP Registration</span>

                        </Link>
                      </li>
                      <li className={isActive("/dashboard/name-publication") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/name-publication" onClick={() => localStorage.removeItem("publicationId")}>
                          <span className="nav-text">Name Publication</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-object") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-object" onClick={() => localStorage.removeItem("panObjectId")}>
                          <span className="nav-text">PAN Object</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-find") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-find" onClick={() => localStorage.removeItem("panFindId")}>
                          <span className="nav-text">PAN Find</span>
                        </Link>
                      </li>

                      <li className={isActive("/dashboard/correction-pan-application") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/correction-pan-application" onClick={() => localStorage.removeItem("correctionPanId")}>
                          <span className="nav-text">Correction PAN Application</span>
                        </Link>
                      </li>
                    </div>
                  </ul>
                </li>
              </>
            )}
            {(userRole === 1) && (
              <>
                <li className="has-sub">
                  <button className="sidenav-item-link" herf="#" onClick={(e) => e.preventDefault()} data-toggle="collapse" data-target="#email1"
                    aria-expanded="false" aria-controls="email1" style={{ cursor: 'pointer' }}>
                    <i className="mdi mdi-email"></i>
                    <span className="nav-text">Admin Reports</span> <b className="caret"></b>
                  </button>
                  <ul className="collapse" id="email1" data-parent="#sidebar-menu">
                    <div className="sub-menu">
                      <li className={isActive("/dashboard/new-pan-application-admin-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/new-pan-application-admin-report">
                          <span className="nav-text">PAN Appln Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/camp-registration-admin-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/camp-registration-admin-report">
                          <span className="nav-text">Camp Registration Report</span>

                        </Link>
                      </li>
                      <li className={isActive("/dashboard/name-publication-admin-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/name-publication-admin-report">
                          <span className="nav-text">Name Publication Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-object-admin-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-object-admin-report">
                          <span className="nav-text">PAN Object Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/pan-find-admin-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/pan-find-admin-report">
                          <span className="nav-text">Pan Find Report</span>
                        </Link>
                      </li>

                      <li className={isActive("/dashboard/correction-pan-application-admin-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/correction-pan-application-admin-report">
                          <span className="nav-text">Correction PAN Appln Report</span>
                        </Link>
                      </li>
                      <li className={isActive("/dashboard/new-address-admin-report") ? "active" : ""}>
                        <Link className="sidenav-item-link" to="/dashboard/new-address-admin-report">
                          <span className="nav-text">New Address report</span>
                        </Link>
                      </li>

                    </div>
                  </ul>
                </li>
                <li>
                  <Link className="sidenav-item-link" to="/AdminSignup">
                    <i className="mdi mdi-ungroup"></i>
                    <span className="nav-text">Admin Login</span>
                  </Link>
                </li>
                {/* <li className="has-sub">
              <button className="sidenav-item-link" href="#" onClick={(e) => e.preventDefault()} data-toggle="collapse" data-target="#ui-elements1"
                aria-expanded="false" aria-controls="ui-elements1" style={{ cursor: 'pointer' }}>
                <i className="mdi mdi-account-edit"></i>
                <span className="nav-text">Admin Form</span> <b className="caret"></b>
              </button>
              <ul className="collapse" id="ui-elements1" data-parent="#sidebar-menu">
                <div className="sub-menu">
                  <li>
                    <Link className="sidenav-item-link" to="new-pan-application-form">
                      <span className="nav-text">New PAN Appln Form</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="sidenav-item-link" to="correction-pan-application-form">
                      <span className="nav-text">Correction PAN Appln Form</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="sidenav-item-link" to="name-publication-form">
                      <span className="nav-text">Name Publication Form</span>
                    </Link>
                  </li>
                  
                  <li>
                    <Link className="sidenav-item-link" to="pan-object-form">
                      <span className="nav-text">PAN Object Form</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="sidenav-item-link" to="camp-registration-form">
                      <span className="nav-text">CAMP Registration Form</span>

                    </Link>
                  </li>
                  <li>
                      <Link className="sidenav-item-link" to="pan-find-form">
                        <span className="nav-text">Pan Find Form</span>
                      </Link>
                    </li>
                </div>
              </ul>
            </li>                  */}
              </>
            )}
            <li className={isActive("/dashboard/rise-ticket") ? "active" : ""}>
              <Link className="sidenav-item-link" to="/dashboard/rise-ticket">
                <i className="mdi mdi-ticket"></i>
                <span className="nav-text">Rise Ticket</span>
              </Link>
            </li>

            <li className={isActive("/dashboard/address-update") ? "active" : ""}>
              <Link className="sidenav-item-link" to="/dashboard/address-update" onClick={() => localStorage.removeItem("addressUpdateId")}>
                <i className="mdi mdi-map-marker"></i>
                <span className="nav-text">Address Update</span>
              </Link>
            </li>

            <li>
              <Link className="sidenav-item-link" to="/">
                <i className="mdi mdi-logout"></i>
                <span className="nav-text">Logout</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
